export default __webpack_public_path__ + "556d52ef8758e9466f0fc25bd14939a6.jpg";